<section class="trust-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>From First Call To Picture Wrap</h2>
            <p>Beyond logistics and permits, we work shoulder-to-shoulder with international teams, making every shooting day easier, friendlier, and more productive.</p>
        </div>

        <div class="trust-content bts-intro">
            <div class="text-center pt-2">
                <a routerLink="/contact" class="btn cta-btn">Plan A Smooth Shoot Experience</a>
            </div>
        </div>
    </div>
</section>

<section class="work-area work-area-three pb-100">
    <div class="container-fluid">
        <div class="section-title">
            <h2>On Set Moments</h2>
        </div>

        <div *ngIf="onSetMomentsLoading" class="row">
            <div class="col-sm-6 col-lg-4" *ngFor="let item of onSetMomentsSkeletonItems">
                <div class="work-item bts-feedback-card skeleton"></div>
            </div>
        </div>

        <div *ngIf="!onSetMomentsLoading && onSetMomentsError" class="row">
            <div class="col-12">
                <div class="service-feedback service-error">
                    <strong>Unable to load on set moments.</strong>
                    <span>{{ onSetMomentsError }}</span>
                </div>
            </div>
        </div>

        <div *ngIf="!onSetMomentsLoading && !onSetMomentsError && onSetMoments.length === 0" class="row">
            <div class="col-12">
                <div class="service-feedback service-empty">
                    No on set moments were returned from WordPress. Add items under WordPress and refresh this page.
                </div>
            </div>
        </div>

        <div class="row" *ngIf="!onSetMomentsLoading && !onSetMomentsError && onSetMoments.length > 0">
            <div class="col-sm-6 col-lg-4" *ngFor="let item of onSetMoments; trackBy: trackByOnSetMoment">
                <div class="work-item bts-feedback-card">
                    <img *ngIf="item.imageUrl" [src]="item.imageUrl" [alt]="item.imageAlt">
                    <div class="feedback-overlay">
                        <p *ngIf="item.quote">{{ item.quote }}</p>
                        <h3>{{ item.personRole }}</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
